import { render } from "./ModalPurchaseCredit.vue?vue&type=template&id=5ef6ad57&scoped=true&ts=true"
import script from "./ModalPurchaseCredit.vue?vue&type=script&lang=ts"
export * from "./ModalPurchaseCredit.vue?vue&type=script&lang=ts"

import "./ModalPurchaseCredit.vue?vue&type=style&index=0&id=5ef6ad57&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef6ad57"]])

export default __exports__